export const INTERVIEW_ID_KEY = "active_interview_id";
export const PROGRESS_KEY = (id) => `interview_progress_${id}`;
export const LOG_KEY = (id) => `interview_log_${id}`;
export const SESSION_KEY = (id) => `interview_session_${id}`;

// ── interviewId ─────────────────────────────────────────────────────────────
export const persistInterviewId = (id) => {
  try {
    if (id) localStorage.setItem(INTERVIEW_ID_KEY, id);
  } catch (_) {}
};

export const getPersistedId = () => {
  try {
    return localStorage.getItem(INTERVIEW_ID_KEY) || null;
  } catch (_) {
    return null;
  }
};

export const clearPersistedId = () => {
  try {
    localStorage.removeItem(INTERVIEW_ID_KEY);
  } catch (_) {}
};

// ── progress ────────────────────────────────────────────────────────────────
export const saveProgress = (id, data) => {
  try {
    localStorage.setItem(PROGRESS_KEY(id), JSON.stringify(data));
  } catch (_) {}
};

export const loadProgress = (id) => {
  try {
    const r = localStorage.getItem(PROGRESS_KEY(id));
    return r ? JSON.parse(r) : null;
  } catch (_) {
    return null;
  }
};

export const clearProgress = (id) => {
  try {
    localStorage.removeItem(PROGRESS_KEY(id));
  } catch (_) {}
};

// ── session tracker ─────────────────────────────────────────────────────────
export const loadSession = (id) => {
  try {
    const r = localStorage.getItem(SESSION_KEY(id));
    return r ? JSON.parse(r) : null;
  } catch (_) {
    return null;
  }
};

export const saveSession = (id, data) => {
  try {
    localStorage.setItem(SESSION_KEY(id), JSON.stringify(data));
  } catch (_) {}
};

export const clearSession = (id) => {
  try {
    localStorage.removeItem(SESSION_KEY(id));
  } catch (_) {}
};

// ── time helpers ────────────────────────────────────────────────────────────
// FIX 1: was using {} braces without return — always returned undefined.
// Using arrow function with () so the expression is implicitly returned.
// FIX 2: subtracting timezone offset from UTC gives correct local wall-clock
// time, then slice(0,19) trims the trailing ".000Z" → "YYYY-MM-DDTHH:MM:SS"
const toLocalIsoSeconds = (d) => {
  const pad2 = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}T${pad2(d.getHours())}:${pad2(d.getMinutes())}:${pad2(d.getSeconds())}`;
};

// ── logs ────────────────────────────────────────────────────────────────────
export const addLog = (id, event, question = null, extra = {}) => {
  try {
    if (!id) return;
    const logs = JSON.parse(localStorage.getItem(LOG_KEY(id)) || "[]");
    const now = new Date();
    const entry = {
      event_name: event,
      interviewId: id,
      question_number: question,
      ...extra,                          // extra first — cannot overwrite timestamps
      timestamp: now.toISOString(),      // e.g. "2026-03-17T10:33:59.509Z"
      localTime: toLocalIsoSeconds(now), // e.g. "2026-03-17T16:03:59"
    };
    logs.push(entry);
    localStorage.setItem(LOG_KEY(id), JSON.stringify(logs));
    console.log("[Interview Log]", entry);
  } catch (_) {
    // Never throw — logging must never break functionality
  }
};

export const getLogs = (id) => {
  try {
    return JSON.parse(localStorage.getItem(LOG_KEY(id)) || "[]");
  } catch (_) {
    return [];
  }
};

export const clearLogs = (id) => {
  try {
    localStorage.removeItem(LOG_KEY(id));
  } catch (_) {}
};

// Clear ALL localStorage keys for one interviewId (full reset)
export const clearAllForInterview = (id) => {
  clearProgress(id);
  clearLogs(id);
  clearSession(id);
};